'use client';

import classNames from 'classnames';

import { PropsWithClassname } from '@/app/types';

export enum AvatarSize {
  Small = 'small',
  ExtraSmall = 'ExtraSmall',
  Medium = 'medium',
}

export enum AvatarStyle {
  Primary = 'primary',
  Secondary = 'secondary',
}

interface AvatarProps extends PropsWithClassname {
  imageUrl?: string;
  placeholderText: string;
  size?: AvatarSize;
  style?: AvatarStyle;
  onClick?: () => void;
}

const Avatar = ({
  imageUrl,
  placeholderText,
  size = AvatarSize.Medium,
  style = AvatarStyle.Secondary,
  onClick,
  className,
}: AvatarProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        className,
        'flex justify-center items-center rounded-full text-center leading-[56px] shrink-0 grow-0',
        {
          'w-[56px] h-[56px]': size === AvatarSize.Medium,
          'w-[42px] h-[42px]': size === AvatarSize.Small,
          'w-[40px] h-[40px]': size === AvatarSize.ExtraSmall,
          'text-secondary-mid text-[32px] font-[Newzald] bg-secondary-light': style === AvatarStyle.Secondary,
          'text-primary-mid text-[16px] bg-primary-light': style === AvatarStyle.Primary,
        },
      )}
    >
      {!!imageUrl && (
        <img
          width={size === AvatarSize.Small ? 42 : 56}
          height={size === AvatarSize.Small ? 42 : 56}
          src={imageUrl}
          alt={placeholderText}
          className={classNames('rounded-full', {
            'w-[56px] h-[56px]': size === AvatarSize.Medium,
            'w-[42px] h-[42px]': size === AvatarSize.Small,
          })}
        />
      )}
      {!imageUrl && (
        <span
          className={classNames({
            'text-secondary-mid font-bold': style === AvatarStyle.Secondary,
            'text-primary-mid': style === AvatarStyle.Primary,
          })}
        >
          {placeholderText.charAt(0).toUpperCase()}
        </span>
      )}
    </div>
  );
};

export default Avatar;
